'use client';
import {CSSProperties} from "react";
import {SuffixButton} from "@web-libs/ui/ui-components/buttons/suffix-button";
import RegisterIcon from "@web-libs/ui/svgs/icons/RegisterIcon";
import {useDictionaryContext} from "@web-libs/core/internationalization/dictionary.context";
import {useAuth} from "@web-libs/features/auth/main/application/use-auth.concern";

export type SignInButtonProps = {
    style?: CSSProperties
}

export const SignInButton = ({style}: SignInButtonProps ) => {
    const dict = useDictionaryContext();
    const auth = useAuth()
    const onClick = () => {
        auth.requestLogin()
    }

    return (
        <SuffixButton color={"light"} textSize={'lg'} suffix={{svg:RegisterIcon}} text={dict.logIn} style={{ ...style}} onClick={onClick} />
    )
}
